// extracted by mini-css-extract-plugin
export default {"grid":"ManualsList_grid__dClZ6"};